import { FieldCondition, ConditionalRule } from '../models/form-field.model';

export type FormValues = Record<string, string | string[] | null | undefined>;

function testCondition(cond: FieldCondition, values: FormValues): boolean {
  if (!cond.field_key) return false;
  const raw = values[cond.field_key];
  const val = Array.isArray(raw) ? raw.join(',') : (raw ?? '');

  switch (cond.operator) {
    case 'equals':
      return val === (cond.value ?? '');
    case 'not_equals':
      return val !== (cond.value ?? '');
    case 'contains':
      return !!(cond.value) && val.includes(cond.value);
    case 'not_empty':
      return val.trim().length > 0;
    case 'is_empty':
      return val.trim().length === 0;
    case 'greater_than': {
      if (!cond.value) return false;
      const numVal = parseFloat(val);
      const numTarget = parseFloat(cond.value);
      if (!isNaN(numVal) && !isNaN(numTarget)) {
        return numVal > numTarget;
      }
      return val > cond.value;
    }
    case 'less_than': {
      if (!cond.value) return false;
      const numVal = parseFloat(val);
      const numTarget = parseFloat(cond.value);
      if (!isNaN(numVal) && !isNaN(numTarget)) {
        return numVal < numTarget;
      }
      return val < cond.value;
    }
    default:
      return false;
  }
}

/**
 * Evalúa una regla condicional contra los valores actuales del formulario.
 * Devuelve true si la acción aplica (el campo debe mostrarse / ocultarse / ser obligatorio).
 */
export function evaluateRule(rule: ConditionalRule, values: FormValues): boolean {
  if (!rule.conditions?.length) return false;

  if (rule.logic === 'or') {
    return rule.conditions.some(c => testCondition(c, values));
  }
  return rule.conditions.every(c => testCondition(c, values));
}

/** Parsea el JSON string almacenado en conditionalRules. Devuelve null si inválido. */
export function parseConditionalRule(raw: string | null | undefined): ConditionalRule | null {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (parsed?.action && parsed?.logic && Array.isArray(parsed?.conditions)) {
      return parsed as ConditionalRule;
    }
    return null;
  } catch {
    return null;
  }
}
